import 'moment/locale/pt-br';

import {
  FileExcelOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  LoadingOutlined,
  RightOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Modal,
  notification,
  Row,
} from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import Fullscreen from 'react-full-screen';

import Localizacao from '../../components/Localizacao';
import SubHeader from '../../components/SubHeader';
import { DATA_MINIMA_PAINEL_EMBARQUE } from '../../config/params';
import { pegarDataUtc } from '../../helpers/data';
import { downloadPDF } from '../../helpers/download';
import { prepareDataAntdTableToCsv } from '../../helpers/export';
import {
  formatarMilhar,
  formatarPorcentagem,
  formatarTelefoneIMask,
  removeThousandSeparatorMask,
} from '../../helpers/formatador';
import { eventGA } from '../../helpers/googleAnalytics';
import {
  getCnpjResumido,
  getCnpjSecundarios,
  getIdUsuario,
  getRazaoSocial,
} from '../../helpers/shipper';
import apiAnalytics from '../../services/apiAnalytics';
import apiATS from '../../services/apiATS';
import apiNetCore from '../../services/apiNetCore';
import apiShipper from '../../services/apiShipper';
import { BtnExportCsv } from '../../styles/Buttons';
import TipoEmissaoTransportadoraEnum from '../Demanda/Enum/TipoEmissaoTransportadoraEnum';
import { getColumns } from './columns';
import DadosMotorista from './DadosMotorista';
import DetalhesDestino from './DetalhesDestino';
import DetalhesOrigem from './DetalhesOrigem';
import InfoCard from './InfoCard';
import {
  validaChildren,
  validaDateToday,
  validaIntegracao,
} from './LocalizacaoMotorista/utils/validaLocalizacao';
import { Table } from './styles';

class PainelEmbarque extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      headerDataTable: 'estado',
      main: 'cliente-integracao',
      cadencia: '',
      cadenciaTon: 0,
      embarcado: '',
      embarcadoTon: 0,
      filaTon: 0,
      emTransitoTon: 0,
      fila: '',
      transito: '',
      aguardandoAprovacao: '',
      aguardandoAprovacaoTon: 0,
      faltaAgenciar: '',
      aderencia: '',
      carregado: '',
      data: [],
      estado: '',
      cliente_integracao_group: true,
      url: '/dashboard',
      modalOrigemVisible: false,
      dataOrigem: {},
      modalDestinoVisible: false,
      dataDestino: {},
      isFull: false,
      breadcrumbList: [],
      filteredInfo: {},
      cadenciaAtualNivelMotorista: 0,
      filteredData: [],
      exportTable: { headers: [], rows: [] },
      modalLocalizacaoVisible: false,
      modalDadosVisible: false,
      dataLocalizacao: {},
      dataMotorista: {},
    };

    this.searchInput = React.createRef();
  }

  componentDidMount() {
    moment.locale('pt-br');
    this.formRef.current.setFieldsValue({ periodo: [moment(), moment()] });
    this.loadDataTable(false);
  }

  getTimeFilter() {
    return this.formRef.current.getFieldValue('periodo');
  }

  updateBreadcrumb(historic) {
    const { breadcrumbList } = this.state;

    let name;
    if (historic.estado || historic.idLote) {
      if (historic.idLote) {
        name = 'Placa';
      } else if (historic.estado) {
        name = historic.estado;
      }
    } else if (historic.cliente_integracao_group) {
      name = 'Estados';
    } else {
      name = 'Voltar';
    }

    breadcrumbList.push({ historic, name });
    this.setState({ breadcrumbList });
  }

  async getData(
    url,
    data_inicio,
    data_fim,
    estado,
    cliente_integracao_group,
    idLote,
    headerDataTable,
    isBreadcrumb,
    main
  ) {
    try {
      const listCnpj = [];
      listCnpj.push(getCnpjResumido());

      if (localStorage.getItem('cliente_secundarios')) {
        listCnpj.push(...getCnpjSecundarios());
      }

      const response = await apiAnalytics.post(url, {
        data_inicio: pegarDataUtc(data_inicio),
        data_fim: pegarDataUtc(data_fim),
        estado,
        cliente_integracao_group,
        id_lote: idLote,
        main,
        cnpjs: listCnpj,
      });
      if (typeof idLote === 'number') {
        response.data.docs.forEach(con => {
          if (con.children.length) {
            con.children.forEach(his => {
              his.key = his.data_acao;
            });
          } else {
            delete con.children;
          }
        });
      }

      if (!isBreadcrumb) {
        this.updateBreadcrumb({
          estado,
          idLote,
          headerDataTable,
          cliente_integracao_group,
        });
      }

      this.tagsCalculation(null, null, null, response.data.docs);
      this.setState({
        loading: false,
        data: response.data.docs,
      });
    } catch (err) {
      this.setState({
        loading: false,
      });
      notification.error({
        message: 'Algo de errado aconteceu',
        description: 'Não foi possível carregar os dados da tabela',
      });
    }
  }

  loadDataTable = async (isBreadcrumb = false) => {
    const {
      headerDataTable,
      estado,
      cliente_integracao_group,
      url,
      idLote,
      main,
    } = this.state;
    const [data_inicio, data_fim] = this.getTimeFilter();

    this.setState({
      loading: true,
    });

    await this.getData(
      url,
      data_inicio,
      data_fim,
      estado,
      cliente_integracao_group,
      idLote,
      headerDataTable,
      isBreadcrumb,
      main
    );
  };

  onClickLocalizacao = async (event, record) => {
    event.stopPropagation();
    if (
      validaChildren(record.children) &&
      validaIntegracao(record?._id?.id_lote_conjunto) &&
      validaDateToday(record, this.getTimeFilter())
    ) {
      try {
        if (record?._id?.id_lote_conjunto > 0) {
          const response = await apiATS.get(
            '/MotoristaBaseAts/GetLocalizacaoMotorista',
            {
              params: {
                idLoteConjunto: record._id.id_lote_conjunto,
              },
            }
          );

          const obj = {
            cidade: response?.data?.cidade,
            estado: response?.data?.estado,
            dataUltimoCheckIn: response?.data?.dataUltimoCheckIn,
            placa: record?.placa,
            status: record?.status_lote_conjunto,
          };

          eventGA(
            'Painel de Embarque',
            'Localização Motorista',
            `Id Usuário - ${getIdUsuario()}`
          );

          this.setState({
            modalLocalizacaoVisible: true,
            dataLocalizacao: obj,
          });
        }
      } catch (err) {
        notification.warning({
          message: 'Ops, não foi possível recuperar a localização',
          description: 'Localização não disponível',
        });
      }
    }
  };

  onClickDadosMotorista = async (event, record) => {
    event.stopPropagation();
    if (validaChildren(record.children)) {
      try {
        if (record?._id?.id_lote_conjunto > 0) {
          const response = await apiNetCore.get(
            '/MotoristaBaseAts/GetDadosMotorista',
            {
              params: {
                idLoteConjunto: record._id.id_lote_conjunto,
              },
            }
          );

          const obj = {
            nome: response?.data?.nome,
            telefone: formatarTelefoneIMask(response?.data?.telefone),
            celular: formatarTelefoneIMask(response?.data?.celular),
          };

          eventGA(
            'Painel de Embarque',
            'Dados do Motorista',
            `Id Usuário - ${getIdUsuario()}`
          );

          this.setState({
            modalDadosVisible: true,
            dataMotorista: obj,
          });
        }
      } catch (err) {
        notification.warning({
          message: 'Ops, não foi possível recuperar os dados do motorista',
          description: 'Dados não disponível',
        });
      }
    }
  };

  onClickAbrirCte = async record => {
    try {
      const { data } = await apiShipper.get(
        `/documentos/${record._id.id_lote_conjunto}`
      );
      const documentoCte = data.filter(item => item.titulo === 'CT-e');
      if (documentoCte && documentoCte[0].link) {
        const response = await apiNetCore.get(`${documentoCte[0].link}`, {
          responseType: 'blob',
        });

        downloadPDF(response.data, Date.now());

        const file = new Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        const pdfWindow = window.open();
        pdfWindow.location.href = fileURL;
      }
    } catch (err) {
      notification.warning({
        message:
          'Ops, não foi possível localizar os dados de documentos para impressão',
        description: 'Dados de documentos não disponível',
      });
    }
  };

  onClickAbrirOrdemCarregamento = async record => {
    try {
      this.setState({
        loading: true,
      });

      let isDocumentoDisponivel = false;
      const response = await apiNetCore.get(
        '/LoteConjuntoAts/GetLoteConjuntoByIdLoteConjunto',
        {
          params: {
            idLoteConjunto: record._id.id_lote_conjunto,
          },
        }
      );

      const responseTipoEmissao = await apiNetCore.get(
        `/Lote/ConsultarTipoEmissao/${response.data.idLote}`
      );

      if (
        responseTipoEmissao.data ===
        TipoEmissaoTransportadoraEnum.TRANSPORTADORA_EXTERNA
      ) {
        const responseListar = await apiNetCore.get(
          `/documento/listar/${response.data.protocolo}`
        );

        if (responseListar.status === 200) {
          const documentoOC = responseListar.data.filter(
            item => item.tipoDocumentoDescricao === 'Ordem de Carregamento'
          );

          const responseDocumento = await apiNetCore.get(
            `/documento/download/${documentoOC[0].id}`,
            {
              responseType: 'blob',
            }
          );

          if (responseDocumento.status === 200) {
            isDocumentoDisponivel = true;
            const file = new Blob([responseDocumento.data], {
              type: responseDocumento.data.type ?? 'application/pdf',
            });
            const fileURL = URL.createObjectURL(file);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;
          }
        }
      } else {
        const { data } = await apiShipper.get(
          `/documentos/${record._id.id_lote_conjunto}`
        );

        const documentoOC = data.filter(
          item => item.titulo === 'Ordem de Carregamento'
        );

        if (documentoOC && documentoOC[0].link) {
          isDocumentoDisponivel = true;
          window.open(
            `${process.env.REACT_APP_ATS_API_URL}${documentoOC[0].link}`
          );
        }
      }

      if (!isDocumentoDisponivel) {
        notification.warning({
          message: 'Ordem de Carregamento',
          description: 'Documento não encontrado',
        });
      }
    } catch (err) {
      notification.warning({
        message:
          'Ops, não foi possível localizar os dados de documentos para impressão',
        description: 'Dados de documentos não disponível',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onClickOrigem = record => {
    this.setState({
      modalOrigemVisible: true,
      dataOrigem: record,
    });
  };

  onClickDestino = record => {
    this.setState({
      modalDestinoVisible: true,
      dataDestino: record,
    });
  };

  closeModalLocalizacao = () => {
    this.setState({
      modalLocalizacaoVisible: false,
    });
  };

  closeModalDados = () => {
    this.setState({
      modalDadosVisible: false,
    });
  };

  closeModalOrigem = () => {
    this.setState({
      modalOrigemVisible: false,
    });
  };

  closeModalDestino = () => {
    this.setState({
      modalDestinoVisible: false,
    });
  };

  handleHeaderDataTable = headerDataTable => {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};

    return getColumns(
      headerDataTable,
      filteredInfo,
      this.formRef,
      this.searchInput,
      this.onClickOrigem,
      this.onClickDestino,
      this.onClickLocalizacao,
      this.onClickDadosMotorista,
      this.onClickAbrirCte,
      this.onClickAbrirOrdemCarregamento
    );
  };

  handleSearchClick = async (btnActions, row, isMain) => {
    const { headerDataTable } = this.state;
    if (btnActions === 'table' && headerDataTable === 'motorista') {
      return;
    }
    try {
      await this.formRef.current.validateFields();
      if (btnActions === 'search') {
        this.loadDataTable(true);
        return;
      }

      let state = {
        estado: '',
        lote_group: false,
        idLote: '',
        cadencia: '',
        cadenciaTon: 0,
        embarcado: '',
        embarcadoTon: 0,
        fila: '',
        filaTon: 0,
        transito: '',
        emTransitoTon: 0,
        aguardandoAprovacao: '',
        aguardandoAprovacaoTon: 0,
        retirado_lote: '',
        faltaAgenciar: '',
        aderencia: '',
        carregado: '',
      };

      if (isMain) {
        state = {
          ...state,
          main: btnActions,
        };
      }
      if (btnActions === 'table') {
        this.setState({ filteredInfo: null });
        state = {
          ...state,
          cadencia: row.cadencia,
          embarcado: `${
            row.embarcado
          } (${row.qtd_peso_total_carregado_hoje.toFixed(2)}T)`,
          fila: row.fila,
          transito: row.transito,
          aguardandoAprovacao: row.aguardando_aprovacao,
          faltaAgenciar: row.falta_agenciar,
          aderencia: row.aderencia,
          carregado: row.carregado,
        };

        if (headerDataTable === 'estado') {
          state = {
            ...state,
            headerDataTable: 'lotes',
            estado: row._id.estado_cliente,
            cliente_integracao_group: false,
          };
        } else if (headerDataTable === 'lotes') {
          state = {
            ...state,
            headerDataTable: 'motorista',
            idLote: row._id.id_lote,
            cliente_integracao_group: false,
          };
        }
      }

      this.setState(state, () => this.loadDataTable(false));
    } catch (err) {
      notification.error({
        message: 'Preencha os campos',
        description: 'Para prosseguir preencha o periodo',
      });
    }
  };

  goBackBreadcrumb = (breadcrumb, index) => {
    const { breadcrumbList } = this.state;

    this.setState({ filteredInfo: null }, () => {
      if (breadcrumbList.length - 1 === index) {
        return;
      }
      const {
        estado,
        idLote,
        headerDataTable,
        cliente_integracao_group,
      } = breadcrumb.historic;

      breadcrumbList.splice(index + 1);
      this.setState(
        {
          breadcrumbList,
          estado,
          idLote,
          cliente_integracao_group,
          headerDataTable,
        },
        () => {
          this.loadDataTable(true);
        }
      );
    });
  };

  tagsCalculation = (pagination, filters, sorter, rows) => {
    const {
      headerDataTable,
      cadencia,
      cadenciaAtualNivelMotorista,
      faltaAgenciar,
    } = this.state;
    if (filters) {
      this.setState({
        filteredInfo: filters,
      });
    }
    const data = rows.currentDataSource ? rows.currentDataSource : rows;
    this.setState({ filteredData: data }, this.prepareCSVExport);

    const calculation = {
      cadencia: headerDataTable === 'motorista' ? cadencia : 0,
      cadenciaTon: 0,
      embarcado: 0,
      embarcadoTon: 0,
      fila: 0,
      filaTon: 0,
      transito: 0,
      aguardandoAprovacao: 0,
      aguardandoAprovacaoTon: 0,
      emTransitoTon: 0,
      retirado_lote: 0,
      faltaAgenciar: headerDataTable === 'motorista' ? faltaAgenciar : 0,
      aderencia: 0,
      carregado: 0,
    };

    if (headerDataTable === 'motorista') {
      calculation.cadencia = cadenciaAtualNivelMotorista || cadencia;
      calculation.faltaAgenciar = cadenciaAtualNivelMotorista || cadencia;

      data.forEach(row => {
        calculation.cadenciaTon = row.cadencia_toneladas;
        const pesoFormatado = removeThousandSeparatorMask(row.peso || 0);

        switch (row.status_lote_conjunto) {
          case 'Em Trânsito':
            calculation.transito += 1;
            calculation.emTransitoTon += pesoFormatado;
            calculation.faltaAgenciar -= 1;
            break;
          case 'Na Fila':
            calculation.fila += 1;
            calculation.filaTon += pesoFormatado;
            calculation.faltaAgenciar -= 1;
            break;
          case 'Embarcado':
            calculation.embarcado += 1;
            calculation.embarcadoTon += pesoFormatado;
            calculation.faltaAgenciar -= 1;
            break;
          case 'Aguardando aprovação':
            calculation.aguardandoAprovacao += 1;
            calculation.aguardandoAprovacaoTon += pesoFormatado;
            calculation.faltaAgenciar -= 1;
            break;
          default:
            break;
        }
      });
    } else {
      data.forEach(row => {
        calculation.cadencia += row.cadencia;
        calculation.cadenciaTon += row.cadencia_toneladas;
        calculation.embarcado += row.embarcado;
        calculation.fila += row.fila;
        calculation.transito += row.transito;
        calculation.aguardandoAprovacao += row.aguardando_aprovacao;
        calculation.faltaAgenciar += row.falta_agenciar;
        calculation.embarcadoTon += row.qtd_peso_total_carregado_hoje;
        calculation.filaTon += row.qtd_peso_total_fila_hoje;
        calculation.emTransitoTon += row.qtd_peso_total_transito_hoje;
        calculation.aguardandoAprovacaoTon +=
          row.qtd_peso_total_aguardando_aprovacao_hoje;
      });
    }

    calculation.aderencia = calculation.cadencia
      ? formatarPorcentagem(
          ((calculation.embarcado + calculation.transito + calculation.fila) /
            calculation.cadencia) *
            100
        )
      : 0;
    calculation.carregado = calculation.cadencia
      ? formatarPorcentagem(
          (calculation.embarcado / calculation.cadencia) * 100
        )
      : 0;

    this.setState({
      ...calculation,
      cadenciaAtualNivelMotorista,
    });
  };

  showTagsContent = (loading, label) => {
    if (loading) {
      return <LoadingOutlined style={{ fontSize: 24 }} spin />;
    }

    if (label.value) {
      return label.value;
    }

    return 0;
  };

  renderBreadcrumb = (breadcrumb, index) => {
    const { name } = breadcrumb;
    const { breadcrumbList } = this.state;
    return (
      <Breadcrumb.Item key={index}>
        <Button
          style={{
            border: 'none',
            padding: '5px',
            color: breadcrumbList.length - 1 !== index || '#1890ff',
            cursor: breadcrumbList.length - 1 !== index || 'default',
          }}
          onClick={e => {
            e.preventDefault();
            this.goBackBreadcrumb(breadcrumb, index);
          }}
        >
          {name}
        </Button>
      </Breadcrumb.Item>
    );
  };

  getCSVFilename = () => {
    const { breadcrumbList } = this.state;

    return `${moment().format(
      'ss.mm.HH-DD-MM-YYYY'
    )}_painel_de_embarque_${breadcrumbList
      .map(his => his.name)
      .join('_')
      .toLowerCase()}.csv`;
  };

  prepareCSVExport = () => {
    const { filteredData, headerDataTable } = this.state;
    const columnsTable = this.handleHeaderDataTable(headerDataTable);
    this.setState({
      exportTable: prepareDataAntdTableToCsv(columnsTable, filteredData),
    });
  };

  render() {
    const {
      loading,
      cadencia,
      cadenciaTon,
      embarcado,
      embarcadoTon,
      fila,
      filaTon,
      transito,
      emTransitoTon,
      aguardandoAprovacao,
      aguardandoAprovacaoTon,
      faltaAgenciar,
      aderencia,
      carregado,
      data,
      headerDataTable,
      modalOrigemVisible,
      modalDestinoVisible,
      dataDestino,
      dataOrigem,
      isFull,
      breadcrumbList,
      exportTable,
      modalLocalizacaoVisible,
      modalDadosVisible,
      dataLocalizacao,
      dataMotorista,
    } = this.state;

    const columnsTable = this.handleHeaderDataTable(headerDataTable);

    return (
      <>
        <SubHeader title={`CONTROLE DE EMBARQUE - ${getRazaoSocial()}`} />

        <Localizacao
          dataLocalizacao={dataLocalizacao}
          modalLocalizacaoVisible={modalLocalizacaoVisible}
          setModalLocalizacaoVisible={this.closeModalLocalizacao}
        />

        <Modal
          zIndex={9999}
          title="Contato motorista"
          visible={modalDadosVisible}
          cancelButtonProps={{ style: { display: 'none' } }}
          okText="Fechar"
          onOk={this.closeModalDados}
          onCancel={this.closeModalDados}
          getContainer=".fullscreen"
        >
          <DadosMotorista dataMotorista={dataMotorista} />
        </Modal>

        <Modal
          zIndex={9999}
          title="Origem"
          visible={modalOrigemVisible}
          cancelButtonProps={{ style: { display: 'none' } }}
          okText="Fechar"
          onOk={this.closeModalOrigem}
          onCancel={this.closeModalOrigem}
          getContainer=".fullscreen"
        >
          <DetalhesOrigem origem={dataOrigem} />
        </Modal>

        <Modal
          zIndex={9999}
          title="Destino"
          visible={modalDestinoVisible}
          cancelButtonProps={{ style: { display: 'none' } }}
          okText="Fechar"
          onOk={this.closeModalDestino}
          onCancel={this.closeModalDestino}
          getContainer=".fullscreen"
        >
          <DetalhesDestino destino={dataDestino} />
        </Modal>

        <Fullscreen
          enabled={isFull}
          onChange={isFullParam => this.setState({ isFull: isFullParam })}
        >
          <Card bordered={false} style={{ height: isFull ? '100vh' : '85vh' }}>
            <Row gutter={16}>
              <Col xs={24} sm={14} md={10} lg={8} xl={5}>
                <Form onSubmit={e => e.preventDefault()} ref={this.formRef}>
                  <Form.Item
                    name="periodo"
                    rules={[
                      {
                        type: 'array',
                        required: true,
                        message: 'Por favor selecione um periodo',
                      },
                    ]}
                  >
                    <DatePicker.RangePicker
                      style={{ width: '100%' }}
                      disabledDate={current =>
                        moment(DATA_MINIMA_PAINEL_EMBARQUE, 'YYYY-MM-DD') >=
                          current || moment().add(3, 'days') <= current
                      }
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Form>
              </Col>
              <Col xs={14} sm={8} md={10} lg={12} xl={16}>
                <Form.Item>
                  <Button
                    icon={<SearchOutlined />}
                    type="primary"
                    onClick={() => this.handleSearchClick('search')}
                    loading={loading}
                  >
                    Pesquisar
                  </Button>
                </Form.Item>
              </Col>
              <Col
                xs={10}
                sm={2}
                md={4}
                lg={4}
                xl={3}
                style={{ textAlign: 'right' }}
              >
                <Form.Item>
                  <CSVLink
                    data={exportTable.rows}
                    headers={exportTable.headers}
                    separator=";"
                    filename={this.getCSVFilename()}
                  >
                    <BtnExportCsv
                      type="dashed"
                      icon={<FileExcelOutlined />}
                      size="middle"
                    />
                  </CSVLink>
                  <Button
                    type={isFull ? '' : 'dashed'}
                    icon={
                      isFull ? (
                        <FullscreenExitOutlined />
                      ) : (
                        <FullscreenOutlined />
                      )
                    }
                    onClick={() => this.setState({ isFull: !isFull })}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <>
                {[
                  {
                    title: 'Cadência',
                    texto: 'Volume',
                    value: cadencia,
                    toneladas: `${formatarMilhar(cadenciaTon, 0, false)} ton`,
                    showTruck: true,
                  },
                  {
                    title: 'Embarcado',
                    texto: 'Volume',
                    value: embarcado,
                    toneladas: `${formatarMilhar(embarcadoTon, 0, false)} ton`,
                    showTruck: true,
                  },
                  {
                    title: 'Fila',
                    texto: 'Volume esperado',
                    value: fila,
                    toneladas: `${formatarMilhar(filaTon, 0, false)} ton`,
                    showTruck: true,
                  },
                  {
                    title: 'Trânsito',
                    texto: 'Volume esperado',
                    value: transito,
                    toneladas: `${formatarMilhar(emTransitoTon, 0, false)} ton`,
                    showTruck: true,
                  },
                  {
                    title: 'A. Aprovação',
                    texto: 'Volume esperado',
                    value: aguardandoAprovacao,
                    toneladas: `${formatarMilhar(
                      aguardandoAprovacaoTon,
                      0,
                      false
                    )} ton`,
                    showTruck: true,
                  },
                  {
                    title: 'F. Agenciar',
                    texto: '',
                    value: faltaAgenciar,
                    toneladas: '',
                    showTruck: true,
                  },
                  {
                    title: 'Aderência',
                    texto: '',
                    value: aderencia,
                    toneladas: '',
                    showTruck: false,
                  },
                  {
                    title: 'Carregado',
                    texto: '',
                    value: carregado,
                    toneladas: '',
                    showTruck: false,
                  },
                ].map(label => (
                  <InfoCard
                    key={label.title}
                    showTagsContent={this.showTagsContent}
                    loading={loading}
                    label={label}
                  />
                ))}
              </>
            </Row>
            <Row gutter={16}>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                style={{ textAlign: 'right' }}
              >
                <Breadcrumb
                  style={{ marginTop: '10px' }}
                  separator={<RightOutlined />}
                >
                  {breadcrumbList.map(this.renderBreadcrumb)}
                </Breadcrumb>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table
                  pagination={false}
                  bordered
                  scroll={{
                    x: 'max-content',
                    y: isFull ? 'calc(100vh - 260px)' : 'calc(100vh - 360px)',
                  }}
                  size="small"
                  expandRowByClick={true}
                  columns={columnsTable}
                  dataSource={data.map((value, i) => ({
                    ...value,
                    key: i,
                  }))}
                  onRow={record => {
                    const onClick = () => {
                      let hasInfo = record.quantidade_lotes !== 0;

                      if (headerDataTable === 'estados') {
                        hasInfo = record.quantidade_lotes > 0;
                      } else if (headerDataTable === 'lotes') {
                        hasInfo =
                          record.fila > 0 ||
                          record.transito > 0 ||
                          record.embarcado > 0 ||
                          record.aguardando_aprovacao > 0;
                      }
                      if (hasInfo) {
                        this.handleSearchClick('table', record);
                      }
                    };
                    return {
                      onClick,
                    };
                  }}
                  loading={loading}
                  onChange={this.tagsCalculation}
                />
              </Col>
            </Row>
          </Card>
        </Fullscreen>
      </>
    );
  }
}

export default PainelEmbarque;
